// Index files serve as entry points for importing and exporting functions and classes only. They should not contain any application logic or implementation details.

import initSearchspringRecommendations from './searchspring-recommendations';
import product from './product';

function index() {
  product();
  initSearchspringRecommendations();
}

export default index;
